import { render, staticRenderFns } from "./AssignServicesToCompanies.vue?vue&type=template&id=55dae3ba&"
import script from "./AssignServicesToCompanies.vue?vue&type=script&lang=ts&"
export * from "./AssignServicesToCompanies.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports